import { initRem } from '@fs/utils'

initRem()
